import { AnnouncementObjectivesFormFileUploadStatus } from '@mailings/components/creators/personalized-mailing-creator-wizard/components/mailing-objectives/forms/file-upload/AnnouncementObjectivesFormFileUploadStatus';
import { ObjectivesFormFilePresenter } from '@mailings/components/creators/personalized-mailing-creator-wizard/components/mailing-objectives/forms/file-upload/ObjectivesFormFilePresenter';
import { AnnouncementFormType } from '@mailings/components/creators/personalized-mailing-creator-wizard/types/mailingObjectivesForm.types';
import {
  INPUT_ACCEPTANCE_CRITERIA,
  OBJECTIVES_FORM_MAX_FILE_SIZE,
} from '@mailings/components/creators/personalized-mailing-creator-wizard/validations/uploadFile.validations';
import { TagContainer } from '@semcore/ui/tag';
import {
  UploadStatus,
  FileRestrictionsErrors,
  FileRestrictions,
} from '@src/types/files-upload-types';
import { useFormContext, useWatch } from 'react-hook-form';

interface AnnouncementObjectivesFormFileUploadProps {
  file: File | null;
  uploadStatus: UploadStatus;
  setUploadStatus: (status: UploadStatus) => void;
  setFileUploadRestrictionsErrors: (
    errors: FileRestrictionsErrors<FileRestrictions> | null,
  ) => void;
  onFileRemove: () => void;
  onFileSelect: (selectedFiles: FileList | null) => void;
  onSelectFromBrandHub: () => void;
  onRemovePressRelease: () => void;
}

export const AnnouncementObjectivesFormFileUpload = ({
  file,
  uploadStatus,
  setUploadStatus,
  setFileUploadRestrictionsErrors,
  onFileRemove,
  onFileSelect,
  onSelectFromBrandHub,
  onRemovePressRelease,
}: AnnouncementObjectivesFormFileUploadProps) => {
  const fileUploaderProps = {
    accept: INPUT_ACCEPTANCE_CRITERIA,
    asFormElement: false,
    fileRestrictions: {
      maxFileSize: OBJECTIVES_FORM_MAX_FILE_SIZE,
      allowedMimeTypes: INPUT_ACCEPTANCE_CRITERIA,
    },
    setFileUploadRestrictionsErrors,
    setFileUploadStatus: setUploadStatus,
    setFiles: onFileSelect,
  };

  const { control } = useFormContext<AnnouncementFormType>();

  const storyId = useWatch({
    control,
    name: 'brandHubStoryId',
    defaultValue: undefined,
  });

  const storyTitle = useWatch({
    control,
    name: 'brandHubStoryTitle',
    defaultValue: '',
  });

  const storyDocumentFile = useWatch({ control, name: 'storyDocumentFile' });

  return (
    <>
      {!file && !storyDocumentFile && !storyId && (
        <AnnouncementObjectivesFormFileUploadStatus
          fileUploaderProps={fileUploaderProps}
          uploadStatus={uploadStatus}
          onSelectFromBrandHub={onSelectFromBrandHub}
        />
      )}

      {!!file && (
        <ObjectivesFormFilePresenter
          file={file}
          onRemove={onFileRemove}
        />
      )}
      {!!storyDocumentFile && !file && (
        <ObjectivesFormFilePresenter
          file={storyDocumentFile}
          onRemove={onRemovePressRelease}
        />
      )}

      {storyId && !storyDocumentFile && (
        <TagContainer
          className="max-w-full self-start"
          size="l">
          <TagContainer.Tag>
            <TagContainer.Tag.Text ellipsis>{storyTitle}</TagContainer.Tag.Text>
          </TagContainer.Tag>
          <TagContainer.Close
            data-test="remove-selected-brandhub-story-button"
            onClick={onRemovePressRelease}
          />
        </TagContainer>
      )}
    </>
  );
};
